import { Flex } from './TremorCompat';
import { Panel } from 'rsuite';
import { MdSpeed as IconSpeed, MdOutlineSchedule as IconClock } from 'react-icons/md';

import { DisplayTimePickerItem } from './DisplayTimePickerItem';
import { DisplayPumpSpeed } from './DisplayPumpSpeed';
import { DisplayTimerEnabledToggleItem } from './DisplayTimerEnabledToggleItem';

export const DisplayFilterTimeItem = (props) => {
  return (
    <Panel bordered={!props.borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4 ">
        <Flex justifyContent="start" className="space-x-4 ">
          <DisplayTimePickerItem
            register={props.timeStartRegister}
            icon={IconClock}
            onChange={props.onTimesChange}
            borderOff={true}
            disabled={props.disabled}
          />
          <DisplayTimePickerItem
            register={props.timeStopRegister}
            onChange={props.onTimesChange}
            borderOff={true}
            disabled={props.disabled}
          />
        </Flex>

        <Flex justifyContent="end" className="space-x-4 ">
          <DisplayPumpSpeed
            register={props.timerSpeedRegister}
            icon={IconSpeed}
            onChange={props.onSpeedChange}
            borderOff={true}
            disabled={props.disabled}
          />
          <DisplayTimerEnabledToggleItem
            register={props.timeStartRegister}
            onChange={props.onEnabledChange}
            disabled={props.disabled}
          />
        </Flex>
      </Flex>
    </Panel>
  );
};
